import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/iotControl';
const iotControl: Array<RouteConfig> = [
    {
        path: 'basic-info/iot-control',
        name: 'iotControl',
        redirect: { name: 'iotDevices' },
        meta: {
            menuMatch: 'iotDevices',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'iot-devices',
                name: 'iotDevices',
                component: () => import(`@/${BASE_PATH}/iotDevices/IotDevices.vue`),
                meta: {
                    index: '2-1',
                },
            },
            {
                path: 'video-monitoring',
                name: 'videoMonitoring',
                component: () => import(`@/${BASE_PATH}/videoMonitoring/VideoMonitoring.vue`),
                meta: {
                    index: '2-2',
                    noBottom:true
                },
            },
            {
                path: 'atmosphere-monitoring',
                name: 'atmosphereMonitoring',
                component: () => import(`@/${BASE_PATH}/atmosphereMonitoring/AtmosphereMonitoring.vue`),
                meta: {
                    index: '2-3',
                    noBottom:true
                },
            },
            {
                path: 'soil-monitoring',
                name: 'soilMonitoring',
                component: () => import(`@/${BASE_PATH}/soilMonitoring/SoilMonitoring.vue`),
                meta: {
                    index: '2-4',
                    noBottom:true
                },
            },
            {
                path: 'insect-monitoring',
                name: 'insectMonitoring',
                component: () => import(`@/${BASE_PATH}/insectMonitoring/InsectMonitoring.vue`),
                meta: {
                    index: '2-5',
                    noBottom:true
                },
            },
            {
                path: 'water-monitoring',
                name: 'waterMonitoring',
                component: () => import(`@/${BASE_PATH}/waterMonitoring/WaterMonitoring.vue`),
                meta: {
                    index: '2-6',
                    noBottom:true
                },
            },
        ],
    },
];
export default iotControl;